import React, { useState } from 'react'
import { Table, Text } from '@mantine/core'
import { formatDateTimeToShow } from 'app/utils/util-functions'
import { Note } from 'app/models/note-params'
import DeleteConfirmation from 'app/views/components/delete-confirmation/DeleteConfirmation'
import 'app/styles/components/notes.css'


interface Props {
    notes: Note[]
    onDeleteNote: (id: string) => void
    onEditNote: (id: string) => void
    onViewNote: (id: string) => void
}

export default function NotesTable({ notes, onDeleteNote, onEditNote, onViewNote }: Props) {

    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false)
    const [selectedNoteId, setSelectedNoteId] = useState<string | null>(null)

    const openDeleteModal = (noteId: string) => {
        setSelectedNoteId(noteId)
        setShowDeleteModal(true)
    }

    const confirmDelete = () => {
        if (selectedNoteId) {
            onDeleteNote(selectedNoteId)
        }
        setShowDeleteModal(false)
        setSelectedNoteId(null)
    }

    return (
        <div className='notes-table'>
            <Table className='note-table' highlightOnHover fontSize="xl" w='100%'>
                <thead>
                    <tr className='note-table-header-row'>
                        <th className='note-table-header-cell column1'><Text className='note-table-header-text'>Note Title</Text></th>
                        <th className='note-table-header-cell'><Text className='note-table-header-text'>Tags</Text></th>
                        <th className='note-table-header-cell'><Text className='note-table-header-text'>Author</Text></th>
                        <th className='note-table-header-cell'><Text className='note-table-header-text'>Date</Text></th>
                        <th className='note-table-header-cell'></th>
                        <th className='note-table-header-cell'></th>
                    </tr>
                </thead>
                <tbody>
                    {notes
                        .sort((a, b) => {
                            const dateA = a.createDate ? new Date(a.createDate).getTime() : 0;
                            const dateB = b.createDate ? new Date(b.createDate).getTime() : 0;
                            return dateB - dateA; // Sort in descending order, most recent on top
                        })
                        .map(note => (
                            <tr
                                className='note-table-body-row'
                                key={note.id}
                                onClick={() => {
                                    if (note.id) {
                                        onViewNote(note.id)
                                    }
                                }}>
                                <td className='note-table-body-cell column1'><Text className='note-table-body-text'>{note.title}</Text></td>
                                <td className='note-table-body-cell'><Text className='note-table-body-text'>{note.tags?.join(', ')}</Text></td>
                                <td className='note-table-body-cell'><Text className='note-table-body-text'>{'LendOS User'}</Text></td>
                                <td className='note-table-body-cell'><Text className='note-table-body-text'>{note.createDate ? formatDateTimeToShow(new Date(note.createDate)) : 'N/A'}</Text></td>
                                <td className='note-table-body-cell'>
                                    <Text
                                        className='note-table-body-text edit-text'
                                        onClick={(e: React.MouseEvent<HTMLParagraphElement>) => {
                                            e.stopPropagation()
                                            if (note.id) {
                                                onEditNote(note.id)
                                            }
                                        }}
                                    >
                                        Edit
                                    </Text>
                                </td>
                                <td className='note-table-body-cell'>
                                    <Text
                                        className='note-table-body-text delete-text'
                                        onClick={(e: React.MouseEvent<HTMLParagraphElement>) => {
                                            e.stopPropagation()
                                            if (note.id) {
                                                openDeleteModal(note.id)
                                            }
                                        }}
                                    >
                                        Delete
                                    </Text>
                                </td>
                            </tr>
                        ))}
                </tbody>
            </Table>
            {/* Delete Confirmation Modal */}
            {showDeleteModal && (
                <DeleteConfirmation
                    onConfirm={confirmDelete} // Delete when confirmed
                    onCancel={() => setShowDeleteModal(false)} // Close modal on cancel
                    message="Delete This Note?" // Custom message
                />
            )}
        </div>
    )
}
